import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
    ...mapState('auth', {
        currentUser: (state) => state.currentUser,
    }),
    ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword','loadRoles'])

/**
 * Representa los roles que se les pueden asingar a los usuarios.
 */
export const Role = {
    /** Administrador del sistema. */
    Administrador: 'Administrador',
    /** Operador del Sistema */
    Operador: 'Operador',
    /** Usuario del Organismo  */
    Organismo: 'Organismo',
    /** Usuario que solo puede realizar capturar información */
    Capturista: 'Capturista',
    /**
     * Cualquier rol puede acceder a este path
     */
    Todos: '*'

}